/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  Descriptions,
  Row,
  Col,
  Image,
  Button,
  Modal,
  Form,
  message,
  Flex,
} from "antd";
import "../OpenTable.css";
import {
  HomeOutlined,
  CloudUploadOutlined,
  BarsOutlined,
  UploadOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { Typography } from "antd";
import UplaodFile from "@/components/UplaodFile";
const { Text, Link } = Typography;
import { useParams } from "react-router-dom";
const MyDetailsPage = () => {
  const childRef = useRef();
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitloading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stepone, setdStepone] = useState([]);
  const [ImgData, setImgData] = useState([]);
  const [detailData, setDetailDat] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  const [nowMainten, setNowMainten] = useState({});
  const [form, formEmail] = Form.useForm();
  const [assignedName, setAssignedName] = useState("");
  const [emailList, setemailList] = useState([]);
  const hasImages = ImgData && ImgData.length > 0;
  const hasPdf = pdfData && pdfData.length > 0;
  const [modelAdd, setModelAdd] = useState(false);
  const [uploadImg, setUploadImg] = useState([]);

  const [fileList, setFileList] = useState([]);
  // const handleFileClick = (url) => {
  //   setPdfUrl(url);
  // };
  const handleFileClick = async (url) => {
    try {
      console.log("下载");
      const res = await fetch(url);
      const blob = await res.blob();
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const objectUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.error("加载 PDF 失败:", err);
    }
  };
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  function transformData(records) {
    if (!records || !Array.isArray(records)) {
      console.error("输入数据无效，必须是一个数组");
      return [];
    }

    const transformedArray = records
      .map((record) => {
        if (!record || !record.emailTo || !record.createTime) {
          console.warn("发现无效的记录，跳过处理:", record);
          return null;
        }

        return {
          emailTo: record.emailTo,
          createTime: record.createTime,
        };
      })
      .filter((item) => item !== null);

    console.log("转换后的数组:", transformedArray);
    return transformedArray;
  }

  // 根据ID 获取详情
  const getDetailImg = async () => {
    try {
      const userID = nowMainten.id;
      if (!userID) {
        console.warn("No userID found. Cannot fetch details.");
        return;
      }
      const response = await http.get(`${api.showDetail}?id=${userID}`);
      if (response.code == 1) {
        setDetailDat(response.data);
        setdStepone(response.data.maintenanceNonFileList);
        const data = response.data.maintenanceNonFileList;
        const filteredFiles = data.filter(
          (file) => file.extension === "pdf" || file.extension === "PDF"
        );
        console.log("Filtered PDF files:", filteredFiles);
        setAssignedName(response.data.assignedName);
        console.log(response.data.assignedName);
        // if (filteredFiles.length > 0) {
        //   setPdfUrl(filteredFiles[0].url);
        //   setPdfData(filteredFiles);
        // } else {
        //   setPdfUrl(null);
        //   setPdfData([]);
        // }
        if (filteredFiles.length > 0) {
          const converted = await Promise.all(
            filteredFiles.map(async (file) => {
              try {
                const res = await fetch(file.url);
                const blob = await res.blob();
                const pdfBlob = new Blob([blob], { type: "application/pdf" });
                const objectUrl = URL.createObjectURL(pdfBlob);
                return {
                  ...file,
                  blobUrl: objectUrl, //  新增 blobUrl
                };
              } catch (err) {
                console.error("PDF 转换失败:", file.fileName, err);
                return file; // 转换失败时用原始 url
              }
            })
          );

          setPdfData(converted);
          setPdfUrl(converted[0].blobUrl || converted[0].url); // 默认展示第一个
        } else {
          setPdfUrl(null);
          setPdfData([]);
        }
        const ImgFiles = data.filter(
          (file) =>
            file.extension === "jpg" ||
            file.extension === "png" ||
            file.extension === "JPG" ||
            file.extension === "jpeg" ||
            file.extension === "PNG" ||
            file.extension === "gif" ||
            file.extension === "bmp" ||
            file.extension === "webp" ||
            file.extension === "svg" ||
            file.extension === "ico" ||
            file.extension === "tif" ||
            file.extension === "tiff"
        );

        setImgData(ImgFiles);
        console.log("response.data", response.data);
        if (response.data.maintenanceNonEmailRecords.length > 0) {
          const transformedData = transformData(
            response.data.maintenanceNonEmailRecords
          );
          console.log("===============", transformedData);
          setemailList(transformedData);
        }
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      // setBtnLoading(false); // 设置加载状态
    }
  };

  const fetchData = async () => {
    try {
      // 获取路由跳转数据
      await new Promise((resolve) => setTimeout(resolve, 1000));
      let params = {};
      const searchParams = new URLSearchParams(window.location.search);
      params = Object.fromEntries(searchParams.entries());
      if (Object.keys(params).length === 0) {
        const hash = window.location.hash.slice(1);
        const [route, queryString] = hash.split("?");
        if (queryString) {
          params = Object.fromEntries(
            new URLSearchParams(queryString).entries()
          );
        }
      }
      console.log("params:", params);
      setNowMainten(params);
      setAssignedName(params.assignedName);
      setTime(params.createTime);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // modal
  const showModal = () => {
    setModelAdd(true);
  };

  const addUoload = async (data) => {
    console.log(data);
    const uploadedFiles = await uploadFiles(data);
    console.log("上传成功的文件信息:", uploadedFiles);
    form.setFieldsValue({ files: uploadedFiles }); // 将格式化后的文件信息设置到表单中
  };

  async function uploadFiles(data) {
    const files = []; // 存储上传成功后的文件信息
    for (const item of data) {
      const formData = new FormData();
      // console.log(item.originFileObj);
      formData.append("files", item.originFileObj); // 将文件添加到 FormData 中
      // console.log(formData);
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value.name}`);
      }
      // console.log(data);
      try {
        const response = await http.post(`${api.UploadFile}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log(response);
        if (response.code === "1") {
          // console.log("=======8888===========");
          const result = response.data;
          // console.log(result);
          files.push(result[0]);
          // console.log(files);
          setFileList(files);
        }
      } catch (error) {
        console.error("上传出错:", error);
      }
    }
    return files;
  }

  const onFinish = async (values) => {
    try {
      setSubmitLoading(true);
      const queryParams = {
        id: nowMainten.id,
        paths: fileList,
      };
      const response = await http.post(
        `${api.getNonMaintenanceAddFiles}`,
        queryParams
      );

      if (response.code === "1") {
        message.success("Add successfully");
        setModelAdd(false);
        await getDetailImg();

        form.resetFields();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error("Submit an error and try again later.");
    } finally {
      setSubmitLoading(false);
    }
  };
  const handleDownload = async (url, fileName) => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();

      // 强制转换为 PDF blob
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // 创建临时 a 标签下载
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = fileName || "file.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      // 释放 blob url
      URL.revokeObjectURL(pdfUrl);
    } catch (e) {
      console.error("下载 PDF 失败:", e);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (nowMainten.id) {
      getDetailImg();
    }
  }, [nowMainten.id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!nowMainten) {
    return <div>No data available.</div>;
  }

  return (
    <div>
      <Row>
        <Col span={14}>
          <Descriptions
            title={
              <div className="detailTitle">
                <div>
                  <HomeOutlined style={{ marginRight: 8 }} />
                  Non Maintenance History Details
                </div>
              </div>
            }
            bordered
            className="detailMain"
            column={1}
          >
            <Descriptions.Item label="Completed Date & Time:">
              {nowMainten.createTime
                ? moment(Number(nowMainten.completedTime)).format(
                    "MM/DD/YYYY HH:mm"
                  )
                : "Invalid time"}
            </Descriptions.Item>
            <Descriptions.Item label="Comp.Remark:">
              {nowMainten.completedRemark || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Completed By:">
              {nowMainten.completedByName || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Created Date & Time:">
              {nowMainten.createTime
                ? moment(Number(nowMainten.createTime)).format(
                    "MM/DD/YYYY HH:mm"
                  )
                : "Invalid time"}
            </Descriptions.Item>
            <Descriptions.Item label="Remark:">
              {nowMainten.remark || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Assigned:">
              {assignedName || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Prop-Unit:">
              {nowMainten.propUnit || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Unit Status:">
              {nowMainten.unitStatus || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Prop Type:">
              {nowMainten.propType || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Units:">
              {nowMainten.units || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Unit Address:">
              {nowMainten.unitAddress || ""}
            </Descriptions.Item>
            <Descriptions.Item label="city:">
              {nowMainten.city || ""}
            </Descriptions.Item>

            <Descriptions.Item label="Requested By:">
              {detailData.roleAllName || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Sent Email Records:">
              {emailList.map((email, index) => (
                <div key={index}>
                  {email.emailTo} -{" "}
                  {email.createTime
                    ? moment(Number(email.createTime)).format(
                        "MM/DD/YYYY HH:mm"
                      )
                    : "Invalid time"}
                  <br />
                </div>
              ))}
            </Descriptions.Item>
          </Descriptions>
        </Col>

        <Col span={10}>
          <div className="detailsRight">
            <div
              className="detailsRightHeader"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <CloudUploadOutlined style={{ marginRight: 8 }} />
                Attachment
              </div>
              <div style={{ marginLeft: 20 }}>
                <Button
                  className="btnGreen"
                  onClick={showModal}
                  icon={<UploadOutlined />}
                >
                  Upload
                </Button>
              </div>
            </div>
            <div className="deMain">
              <div>
                <div className="mainPDF">
                  {hasImages && (
                    <div
                      className="IMGbox"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "12px",
                        width: "100%",
                      }}
                    >
                      {ImgData.map((item, index) => (
                        <div
                          key={index}
                          className="imageWrapper"
                          style={{
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#f5f5f5",
                            borderRadius: "4px",
                            overflow: "hidden",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          <Image
                            width={100}
                            height={100}
                            style={{
                              objectFit: "cover",
                              maxWidth: "100%",
                              maxHeight: "100%",
                            }}
                            src={item.url}
                            alt={`Image ${index + 1}`}
                            preview={{
                              maskClassName: "custom-preview-mask",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  {hasPdf && (
                    <>
                      <div
                        className="mainName"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignContent: "flex-start",
                          width: "100%",
                          gap: "8px",
                        }}
                      >
                        {/* {pdfData.length > 0
                          ? pdfData.map((item, index) => (
                              <a
                                key={index}
                                onClick={() => handleFileClick(item.url)}
                              >
                                <BarsOutlined
                                  style={{
                                    marginRight: "8px",
                                    marginTop: "3px", 
                                  }}
                                />
                                <span>{item.fileName}</span>
                              </a>
                            ))
                          : null} */}
                        {pdfData.length > 0
                          ? pdfData.map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <a onClick={() => handleFileClick(item.url)}>
                                  <BarsOutlined
                                    style={{
                                      marginRight: "8px",
                                      marginTop: "3px",
                                    }}
                                  />
                                  <span>{item.fileName}</span>
                                </a>

                                <button
                                  onClick={() =>
                                    handleDownload(item.url, item.fileName)
                                  }
                                  style={{
                                    border: "none",
                                    background: "none",
                                    cursor: "pointer",
                                    color: "#1890ff",
                                  }}
                                >
                                  <VerticalAlignBottomOutlined />
                                  Download
                                </button>
                              </div>
                            ))
                          : null}
                      </div>
                      <div className="PDFbox">
                        <iframe
                          src={pdfUrl}
                          title="PDF Viewer"
                          width="100%"
                          style={{ height: "80vh" }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <UploadOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              Upload File
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={modelAdd}
        onCancel={() => {
          setModelAdd(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setModelAdd(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submitloading}
            onClick={(e) => {
              e.preventDefault();
              form.submit();
            }}
          >
            Submit
          </Button>,
        ]}
        styles={{
          body: {
            height: "300px",
            overflowY: "auto",
            padding: "24px",
          },
        }}
      >
        <Form
          {...layout}
          onFinish={onFinish}
          form={form}
          labelCol={{ span: 2 }}
          className="model_top"
        >
          <Form.Item name="files" label="Files" style={{ marginTop: "20px" }}>
            <UplaodFile
              ref={childRef}
              uploadImg={uploadImg}
              sendDataToParent={addUoload}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MyDetailsPage;
